export default __webpack_public_path__ + "static/media/phone_icon_ikara.c76d5b63.png";